<template>
  <v-dialog
      v-model="showImportDialog"
      scrollable
      max-width="600px"
  >
    <v-card>
      <v-card-title>Mitarbeiter Importieren</v-card-title>
      <v-divider></v-divider>
      <v-card-text style="max-height: 800px;">
        <v-row>
          <v-col cols="3">
            <v-text-field
                v-model="sheetnumber"
                label="Seitennummer"
                hint="(Startet bei 0)"
                type="number"
                @input="onImportFile"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="headerRowNumber"
                label="Zeilennummer Überschrift"
                hint="(Startet bei 0)"
                type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="5">
            <v-file-input
                v-model="excelFile"
                accept=".xlsx, .xls, .csv"
                label="Datei auswählen"
                @change="onImportFile"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-divider/>
        <v-row>
          <v-col>
            <h5 class="m-0">Spalte der Datei</h5>
          </v-col>
          <v-col>
            <h5 class="m-0">Spalte Stammdatum</h5>
          </v-col>
        </v-row>
        <v-divider/>
        <v-row v-for="(col, index) in excelData" :key="'col-' + index" class="m-0">
          <v-col class="p-0"><h6 style="margin-top: 22px; margin-bottom: 0px">{{col.data[headerRowNumber]}}</h6></v-col>
          <v-col class="p-0">
            <v-autocomplete
                v-model="columnMapping['col-' + index]"
                :items="possibleSelects"
                item-text="text"
                item-value="value"
                clearable
                hide-details
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="showImportDialog = false"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            :disabled="!excelFile && sheetnumber !== ''"
            @click="importExcel"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar
        v-model="showErrorMessage"
        :timeout="8000"
        right
        color="red accent-2"
    >
      <b>{{ errorMessage }}</b>

      <template v-slot:action="{ attrs }">
        <v-btn
            icon
            color="white"
            v-bind="attrs"
            @click="showErrorMessage = false"
        >
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import parseFile from "@/views/basis_data/FileParser";

export default {
  name: "ParseFileDialog",
  props: {
    cols: {
      type: Array,
      default: () => [],
    },
    preDefinedData: {
      type: Array,
      default: () => [],
    },
    emptyItem: {
      type: Object,
      default: () => {},
    },
    transformItem: {
      type: Function,
      default: (item) => item,
    },
  },
  data() {
    return {
      excelFile: null,
      sheetnumber: '0',
      headerRowNumber: '0',
      showImportDialog: false,
      excelData: [],
      columnMapping: {},
      showErrorMessage: false,
      errorMessage: '',
    }
  },
  computed: {
    possibleSelects() {
      let selects = [];
      for (let i = 0; i < this.cols.length; i++) {
        let col = this.cols[i];
        if (col.type !== 'readonly' && col.type !== 'hidden') {
          selects.push({value: col.name, text: col.title})
        }
      }
      // sort
      selects.sort((a, b) => {
        return a.text.localeCompare(b.text);
      });
      return selects;
    }
  },
  methods: {
    importExcel() {
      let res = [];
      let start = parseInt(this.headerRowNumber) + 1;
      for (let i = start; i < this.excelData[0].data.length; i++) {

        let row = {...this.emptyItem};
        for (let j = 0; j < this.excelData.length; j++) {
          let col = this.columnMapping['col-' + j];
          if (col) {
            row[col] = this.excelData[j].data[i];
          }
        }
        res.push(this.transformItem(row));
      }
      this.$emit('import', res);
      this.showImportDialog = false;
      this.excelFile = null;
      this.sheetnumber = '0';
      this.headerRowNumber = '0';
    },
    onImportFile() {
      if (!this.excelFile) {
        return;
      }
      parseFile(this.excelFile, "text[this.lang]", parseInt(this.sheetnumber)).then((results) => {
        for (let i = 0; i < this.excelData.length; i++) {
          if (!this.columnMapping['col-' + i]) {
            this.columnMapping['col-' + i] = '';
          }
        }
        this.excelData = results;
      }).catch((error) => {
        this.errorMessage = error;
        this.showErrorMessage = true;
        console.log(error);
      });
    },
    show() {
      this.columnMapping = {};
      for (let i = 0; i < this.preDefinedData.length; i++) {
        this.columnMapping['col-' + i] = this.preDefinedData[i];
      }
      this.showImportDialog = true;
    }
  }
}
</script>

<style scoped>

</style>
